












import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class LoaderFadeOut extends Vue {
  private show: boolean = true;
  private enter(el: any, done: any) {
    setTimeout(() => (this.show = false), 400); // hide the message after 0.4 seconds
  }
}
